/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDistanceSource.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/distance-source";

export class AutogenModelDistanceSource<RowType extends ModelRow> extends Endpoint<RowType, RowDistanceSourceFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDistanceSource extends ModelRow<RowDistanceSourceFields> {
	constructor(values?: Partial<RowDistanceSourceFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDistanceSourceFields {
	company_id: string;
	create_location_from_stop: string;
	create_order_hist: string;
	cross_ref_table: string;
	descr: string;
	enable_add_customer_trimble: string;
	enable_add_location_trimble: string;
	enable_stop_lookup: string;
	enable_trimble_places: string;
	host: string;
	id: string;
	location_frm_stop: string;
	methods_required: string;
	mm_auth_created_at: Date;
	mm_auth_token: string;
	port: number;
	street_level: string;
	tolls_capable: string;
	trimble_places_entry_delay: number;
	trimble_places_set_id: number;
	types_required: string;
	webservice_add_customer: string;
	webservice_add_duplicate: string;
	webservice_add_location: string;
	webservice_api_key: string;
	webservice_company: string;
	webservice_license: string;
	webservice_login: string;
	webservice_option_level: string;
	webservice_places: string;
	webservice_pword: string;
	webservice_stop_lookup: string;
	webservice_time: number;
	webservice_url: string;
}

